<template>
  <div class='DatePicker'>
    <el-time-picker @change="change" v-if="formInline.timeType === 'time' && !formInline.timeSection" :disabled='!formInline.compile' arrow-control v-model="formInline.value" :value-format='formInline.formats' placeholder="选择时间"></el-time-picker>
    <el-time-picker @change="change" v-if="formInline.timeType === 'time' && formInline.timeSection" :disabled='!formInline.compile' is-range arrow-control v-model="formInline.value" :value-format='formInline.formats' range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围"></el-time-picker>
    <el-date-picker @change="change" v-if="formInline.timeType === 'data' && !formInline.timeSection" :disabled='!formInline.compile' v-model="formInline.value" :value-format='formInline.formats' type="date" placeholder="选择日期"></el-date-picker>
    <el-date-picker @change="change" v-if="formInline.timeType === 'data' && formInline.timeSection" :disabled='!formInline.compile' v-model="formInline.value" :value-format='formInline.formats' type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
    <el-date-picker @change="change" v-if="formInline.timeType === 'dataTime' && !formInline.timeSection" :disabled='!formInline.compile' v-model="formInline.value" :value-format='formInline.formats' type="datetime" placeholder="选择日期时间"></el-date-picker>
    <el-date-picker @change="change" v-if="formInline.timeType === 'dataTime' && formInline.timeSection" :disabled='!formInline.compile' v-model="formInline.value" :value-format='formInline.formats' type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
  </div>
</template>

<script>
import deepClone from '@/shared/utils/deep-clone'
export default {
  name: 'DatePicker',

  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },

  data () {
    return {
      formInline: { value: '' }
    }
  },

  watch: {
    data (val) {
      this.formInline = deepClone(this.data).controls
    },

    'data.controls.timeSection' (val) {
      this.formInline.value = ''
      this.change()
    },

    'data.controls.timeType' (val) {
      this.formInline.value = ''
      switch (val) {
        case 'data':
          this.formInline.formats = 'yyyy-MM-dd'
          this.change()
          return ''
        case 'time':
          this.formInline.formats = 'HH:mm:ss'
          this.change()
          return ''
        case 'dataTime':
          this.formInline.formats = 'yyyy-MM-dd HH:mm:ss'
          this.change()
          return ''
      }
    }
  },

  mounted () {
    this.formInline = deepClone(this.data).controls
  },

  methods: {
    change () {
      const obj = deepClone(this.data)
      obj.controls = this.formInline
      this.$emit('changeControls', obj)
    }
  }
}
</script>
